// Filename: bumble_raven.js
// Timestamp: 2017.11.17-13:35:44 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import * as Sentry from '@sentry/browser'

const SENTRYDSN = 'https://090df35020db45ca950eb0623e3c6f05@sentry.io/196835'
const win = typeof window === 'object' ? window : {}
const location = win.location || {}

// if not dev host and if raven not *explicitly* disabled
function iscrashreport (hostname, isravendisable) {
  const isdevhost = /dev|test|localhost|0\.0\.0\.0/.test(hostname)
  const devreport = isdevhost && (
    typeof isravendisable === 'boolean' && !isravendisable)
  const prodreport = !isdevhost

  return Boolean(devreport || prodreport)
}

if (iscrashreport(location.hostname)) {
  Sentry.init({ dsn: SENTRYDSN })
}
